import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { DatabaseIcon, BrainCircuitIcon, TrendingUpIcon, TargetIcon } from 'lucide-react';
const capabilities = [{
  id: '01',
  title: 'AI-Driven Analytics & Automation',
  description: 'Implementing AI-driven analytics and workflow automation to unlock operational efficiencies.',
  icon: BrainCircuitIcon
}, {
  id: '02',
  title: 'Financial Management',
  description: 'Providing best practices and real world implementations that save you time and money.',
  icon: TargetIcon
}, {
  id: '03',
  title: 'Operational Advisory',
  description: 'Advising growth-stage and founder-led businesses on operational scale and system integration.',
  icon: TrendingUpIcon
}, {
  id: '04',
  title: 'Vertical SaaS & Data Infrastructure',
  description: 'Building and operating vertical SaaS and data infrastructure platforms tailored to legacy industries.',
  icon: DatabaseIcon
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 30
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.8,
      ease: [0.16, 1, 0.3, 1]
    }
  }
};
export function FocusAreas() {
  return <section id="focus" className="py-32 px-6 md:px-12 max-w-7xl mx-auto border-t border-avm-border" data-id="element-17">
      <div className="mb-20" data-id="element-18">
        <span className="text-avm-accent text-xs font-semibold tracking-[0.2em] uppercase mb-6 block" data-id="element-19">
          Focus Areas
        </span>
        <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-avm-text" data-id="element-20">
          Core Capabilities
        </h2>
      </div>

      <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
      once: true,
      margin: '-100px'
    }} className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8" data-id="element-21">
        {capabilities.map(item => {
        const Icon = item.icon;
        return <motion.div key={item.id} variants={itemVariants} className="group relative p-8 md:p-10 border border-avm-border bg-avm-bgAlt hover:border-avm-accent/50 transition-colors duration-500 flex flex-col h-full" data-id="element-22">
              <div className="mb-12" data-id="element-23">
                <div className="w-10 h-10 flex items-center justify-center border border-avm-accent/30 group-hover:border-avm-accent/60 transition-colors duration-500" data-id="element-24">
                  <Icon className="w-5 h-5 text-avm-accent/70 group-hover:text-avm-accent transition-colors duration-500" strokeWidth={1.5} data-id="element-25" />
                </div>
              </div>

              <div className="mt-auto" data-id="element-26">
                <h3 className="text-xl md:text-2xl font-medium text-avm-text mb-4 tracking-tight" data-id="element-27">
                  {item.title}
                </h3>
                <p className="text-avm-textMuted font-light leading-relaxed" data-id="element-28">
                  {item.description}
                </p>
              </div>
            </motion.div>;
      })}
      </motion.div>
    </section>;
}